import * as React from 'react';
import {
  Grid,
  Card,
  CardHeader,
  Box,
  Paper,
  Divider,
  Button,
  TextField,
  CircularProgress,
} from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import type { IWorkViewDetail } from '../WorkViewInterfaces';
import WorkViewSets from './WorkViewSetsUpsert';
import type ILabelEnumPair from '../../../global/GlobalInterfaces';
import type { ILabelValuePair } from '../../../marking/MarkingInterfaces';

interface IEditPrimaryGroup {
  setWorkViewFormValues: (values: IWorkViewDetail) => void;
  WorkViewFormValues: IWorkViewDetail;
  DisplayStyles?: ILabelEnumPair[];
  bins?: ILabelValuePair[];
  isFetching: boolean;
  workViewIdParam?: string | null;
  handleUpsertWorkView: () => void;
  addNewWorkViewSet: (primaryGroupIndex: number, workViewIndex: number) => void;
  handleAddNewPrimaryGroup: () => void;
  handleWorkViewColorChange: (primaryGroupIndex: number, workViewIndex: number, event: React.ChangeEvent<HTMLInputElement>) => void;
  handleWorkVeiwSetRemove: (primaryGroupIndex: number, workViewIndex: number) => void;
  handleDuplicateWorkViewSet: (primaryGroupIndex: number, workViewIndex: number) => void;
}

const PrimaryGroupUpsert: React.FC<IEditPrimaryGroup> = ({
  setWorkViewFormValues, WorkViewFormValues, DisplayStyles, bins, isFetching, workViewIdParam,
  handleUpsertWorkView, addNewWorkViewSet, handleAddNewPrimaryGroup, handleWorkViewColorChange, handleWorkVeiwSetRemove, handleDuplicateWorkViewSet,
}) => (
  <Grid>
    <Card>
      <Paper>
        <CardHeader title="Add Primary Group(s)" />
        <Divider variant="fullWidth" />
        {
            WorkViewFormValues.primaryGroups?.map((primaryGroup, primaryGroupIndex) => (
              <>
                <Grid item xs={4}>
                  <Box p={2}>
                    <TextField
                      value={primaryGroup.name}
                      id={`primaryGroup-value-input-${primaryGroup.primaryGroupId}`}
                      label="Primary Group Name"
                      variant="outlined"
                      type="string"
                      fullWidth
                      onChange={(event) => {
                        const inputVal = event.target.value;
                        const tempPrimaryGroupValues = WorkViewFormValues.primaryGroups;
                        tempPrimaryGroupValues[primaryGroupIndex].name = inputVal;
                        setWorkViewFormValues({ ...WorkViewFormValues, primaryGroups: tempPrimaryGroupValues });
                      }}
                    />
                  </Box>
                </Grid>
                <WorkViewSets
                  formValues={WorkViewFormValues}
                  setFormValues={setWorkViewFormValues}
                  WorkViewSetsDisplayStyles={DisplayStyles}
                  Bins={bins}
                  handleAddNewWorkViewSet={addNewWorkViewSet}
                  primaryGroupIndex={primaryGroupIndex}
                  handleWorkViewSetColorChange={handleWorkViewColorChange}
                  removeWorkViewSet={handleWorkVeiwSetRemove}
                  duplicateWorkViewSet={handleDuplicateWorkViewSet}
                />
              </>
            ))
          }
        <Grid container direction="row-reverse">
          <Grid item xs={3} style={{ maxWidth: '170px' }}>
            <Box pt={6} pb={4} pr={2}>
              <Button
                style={{ padding: '8px 2px' }}
                fullWidth
                variant="contained"
                color="primary"
                disabled={isFetching}
                onClick={() => { handleUpsertWorkView(); }}
              >
                {
                  isFetching ? (<CircularProgress size={25} />) : `${!workViewIdParam ? 'Create' : 'Update'} Work View`
                }
              </Button>
            </Box>
          </Grid>
          <Grid item xs={2}>
            <Box pr={2} pt={6} pb={4}>
              <Button
                style={{ padding: '8px 2px' }}
                fullWidth
                variant="text"
                color="primary"
                onClick={() => { handleAddNewPrimaryGroup(); }}
              >
                <AddIcon color="primary" />
                {'Add Primary Group'}
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Paper>
    </Card>
  </Grid>
);

export default PrimaryGroupUpsert;
